import Member from "../../services/member/member";
import MemberRoleOrganization from "./member-role-organization";

export default class MemberExtensions {
  static getMemberRoleOrganization(member: Member, organizationId: string): MemberRoleOrganization | undefined {
    return member.associatedOrganizations.find((organization) => organization.entity?.id === organizationId);
  }
}
